var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiamondShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.831 20.4132L5.456 13.5032C4.848 12.7202 4.848 11.2802 5.456 10.5032L10.831 3.59223C10.9666 3.40998 11.1429 3.26196 11.3459 3.15998C11.5488 3.05799 11.7728 3.00488 12 3.00488C12.2272 3.00488 12.4512 3.05799 12.6541 3.15998C12.8571 3.26196 13.0334 3.40998 13.169 3.59223L18.544 10.5022C19.152 11.2852 19.152 12.7252 18.544 13.5022L13.169 20.4132C13.0334 20.5955 12.8571 20.7435 12.6541 20.8455C12.4512 20.9475 12.2272 21.0006 12 21.0006C11.7728 21.0006 11.5488 20.9475 11.3459 20.8455C11.1429 20.7435 10.9666 20.5955 10.831 20.4132Z",
    fill: "#89CDFF",
    stroke: "#89CDFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondShape);
export default __webpack_public_path__ + "static/media/diamond-shape.f3f6c2dfc16bbb51d41f4c8908e4a768.svg";
export { ForwardRef as ReactComponent };